/** 引入阿里云监控 alife-logger */
const BrowerLogger = require('alife-logger');
let cyLog = {
    init: function () {
        var envFormal = location.host.indexOf('changyoyo') >= 0;
        BrowerLogger.singleton({
            pid: envFormal ? "igqkhnclmx@14602e4d7426072" : "igqkhnclmx@f25aa00edae4e86",
            appType: "web",
            imgUrl: "https://arms-retcode.aliyuncs.com/r.png?",
            sendResource: true,
            enableLinkTrace: true,
            behavior: true
        });
    }
}
export default cyLog